module.exports = __webpack_public_path__ + "media/images/features/7/plan-album3-525063a1c6d41fbf0dfa3c95517c7e28.jpg";